<template>
  <MarketInsightsPage
    v-slot="{ slug, categoriesArticles, playVideo }"
    :market="market"
  >
    <NuxtPage
      :slug="slug"
      :categories-articles="categoriesArticles"
      :categories-videos="categoriesArticles"
      @play-video="playVideo"
    />
  </MarketInsightsPage>
</template>

<script setup lang="ts">
import MarketInsightsPage from '~/components/market/MarketInsightsPage.vue'
import { ANODE, MARKET } from '~/constants/services/constants'

const market = {
  ...ANODE,
  hideAnalysis: true,
}

definePageMeta({ layout: 'services' })

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${ANODE.name} Market Insights`,
})
useHead(seo)
</script>
